import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';

import images from '_images';

import { setHelpDamagedCartData as setHelpDamagedCartDataAction } from '../../redux/actions';
import getNextActiveScreen from '../../helpers';

const Container = styled.div`
  width: 80%;
  margin: auto;
  padding: 20px;
`;

const BodyPartsContainer = styled.div`
  margin-bottom: 40px;
  padding-bottom: 15px;
`;

const Button = styled.button`
  width: 100%;
  height: auto;
  border: none;
  display: flex;
  padding: 15px;
  cursor: pointer;
  min-height: 50px;
  margin-bottom: 5px;
  box-sizing: border-box;
  background-color: #fff;
  border-bottom: 1px solid #dbdbdb;
  padding-left: 0 !important;
  align-items: center;
  cursor: pointer;
`;

const TitleContainer = styled.div`
    flex: 1;
`;

const Title = styled.p`
    margin: 0;
    padding: 0;
    font-size: 16px;
    text-align: left;
    font-family: Roboto, sans-serif;
`;

const ArrowContainer = styled.div`
    flex: 1;
    max-width: 16px;
`;

const Arrow = styled.img`
  width: 100%;
  height: 100%;
`;

const DamagedParts = ({
  damaged_cart_data, url, data, damaged_cart_form_data, setHelpDamagedCartData
}) => {
  const { push } = useHistory();
  const { oidx } = useParams();
  const items = useMemo(() => data?.damaged_parts_page.items.split(', '));

  const buttonOnClick = (type) => () => {
    setHelpDamagedCartData({ ...damaged_cart_form_data, damagedParts: type });
    const nextPage = getNextActiveScreen(
      damaged_cart_data.find(({ oidx: index }) => index === Number(oidx)),
      data.page,
      url
    );
    push(nextPage, {
      damaged_cart_data: damaged_cart_data.find(({ oidx: index }) => index === Number(oidx))
    });
  };

  return (
    <Container>
      <BodyPartsContainer>
        <h3>{data?.damaged_parts_page.title}</h3>
        <ul style={{ padding: 0 }}>
          {items.map((item) => (
            <li style={{ listStyle: 'none' }}>
              <Button
                key={item}
                onClick={buttonOnClick(item)}
              >
                <TitleContainer>
                  <Title>{item}</Title>
                </TitleContainer>
                <ArrowContainer>
                  <Arrow
                    src={images.calendar.rightArrow}
                    alt={`${item} button`}
                  />
                </ArrowContainer>
              </Button>
            </li>
          ))}
        </ul>
      </BodyPartsContainer>
    </Container>
  );
};

export default connect(
  (store) => ({
    damaged_cart_data: store?.help?.helpItems.filter(({ type }) => type === 'DAMAGED_CART'),
    damaged_cart_form_data: store?.help?.damagedCartFormData,
  }),
  (dispatch) => ({
    setHelpDamagedCartData: (data) => dispatch(setHelpDamagedCartDataAction(data))
  })
)(DamagedParts);
